import { render, staticRenderFns } from "./DepartPostDrawer.vue?vue&type=template&id=70baa1ec&scoped=true&"
import script from "./DepartPostDrawer.vue?vue&type=script&lang=js&"
export * from "./DepartPostDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DepartPostDrawer.vue?vue&type=style&index=0&id=70baa1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70baa1ec",
  null
  
)

export default component.exports